import { z } from "zod"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { createSortSchema } from "../../shared/sort_dtos"

export const sortFields = [
  "id",
  "name",
  "avgMonthlyCost",
  "currentMonthCost",
  "costPerMessage",
  "mrr",
  "margin",
] as const

export type BackofficeCompanyCostSortFields = (typeof sortFields)[number]

export const CostsSortSchema = createSortSchema(sortFields, "name", "asc")

export const GetBackofficeCompanyCostsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape).extend(CostsSortSchema.shape).shape,
})
